import { useHead } from '@unhead/react';
import { Descriptions } from 'antd';
import { formatDateWithMiddleDot } from 'technical/format/date-format';

import { StatusForm } from './components/status-form';
import { useUpdateSegmentStatus } from './hooks/use-update-segment-status';
import { useTranslation } from 'translations/hooks';
import { ContentHeader } from 'ui/components/content-header';
import { getLocalStorageValue } from 'technical/local-storage';
import { SCAN_SITE_KEY } from 'technical/local-storage/constants';
import {
  scanSiteSchema,
  type ScanSiteSchema,
} from 'technical/local-storage/types';

export const ReceiptChooseSegmentStatusPage = () => {
  const { t } = useTranslation();

  const scanSite = getLocalStorageValue<ScanSiteSchema>({
    key: SCAN_SITE_KEY,
    schema: scanSiteSchema,
  });
  const isQuarantineEnabled = scanSite?.isQuarantineEnabled ?? true;
  const isOnHoldOptionEnabled = scanSite?.isOnHoldOptionEnabled ?? false;

  const {
    form,
    serialNumber,
    segmentType,
    manufactureDate,
    mold,
    currentStatus,
    lastScanSite,
    segmentTypes,
    quarantineDefectTypes,
    initialValues,
    handleSaveStatus,
    isLoading,
  } = useUpdateSegmentStatus();

  useHead({
    title: t('chooseSegmentStatus.title'),
  });

  const items = [
    {
      key: 'serialNumber',
      label: t('chooseSegmentStatus.details.serialNumber'),
      children: serialNumber,
    },
    {
      key: 'segmentType',
      label: t('chooseSegmentStatus.details.segmentType'),
      children: segmentType ?? '-',
    },
    {
      key: 'manufactureDate',
      label: t('chooseSegmentStatus.details.manufactureDate'),
      children: formatDateWithMiddleDot(manufactureDate),
    },
    {
      key: 'mold',
      label: t('chooseSegmentStatus.details.mold'),
      children: mold ?? '-',
    },
    {
      key: 'status',
      label: t('chooseSegmentStatus.details.status'),
      children: currentStatus
        ? t(`chooseSegmentStatus.status.state`, { context: currentStatus })
        : '-',
    },
    {
      key: 'scanSite',
      label: t('chooseSegmentStatus.details.scanSite'),
      children: lastScanSite ?? '-',
    },
  ];

  return (
    <ContentHeader title={t('chooseSegmentStatus.title')}>
      <div className="bg-white px-12 py-2">
        <Descriptions
          items={items}
          colon={false}
          layout="vertical"
          column={3}
        />
      </div>

      <StatusForm
        form={form}
        save={handleSaveStatus}
        segmentTypes={segmentTypes}
        quarantineDefectTypes={quarantineDefectTypes}
        initialValues={initialValues}
        isFetching={isLoading}
        isQuarantineEnabled={isQuarantineEnabled}
        isOnHoldOptionEnabled={isOnHoldOptionEnabled}
      />
    </ContentHeader>
  );
};
